//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TABS, TYPE } from './const'

import Top from './_components/top'
import Tabs from './_components/tabs'
import InRecords from './_components/in_records'
import OutRecords from './_components/out_records'
import User from './_components/user'

import getInRecordsMixin from './_mixins/get_in_records'
import getOutRecordsMixin from './_mixins/get_out_records'

import share from './_mixins/share'

import { compute, setResult } from './data'
import { padStart } from '@/utils/index'

const formatDate = (date) => {
    return date.getFullYear() + '-' + padStart(date.getMonth() + 1)
}

const checkUser = (user) => {
    return user.age && user.gender
}
const checkRecordItem = ({ start, end, val }) => {
    return start && end && val
}
const checkRecords = (records) => {
    return records.every(checkRecordItem)
}

export default {
    mixins: [
        share,
        getInRecordsMixin('in_records'),
        getInRecordsMixin('couple_in_records'),
        getOutRecordsMixin('out_records', {
            in_key: 'in_records'
        }),
        getOutRecordsMixin('couple_out_records', {
            in_key: 'couple_in_records'
        }),
    ],
    components: {
        Top,
        Tabs,
        InRecords,
        OutRecords,
        User
    },
    data () {
        return {
            tabs: TABS,
            type: TYPE.SINGLE,
            user: {
                age: 0,
                gender: ''
            },
            couple: {
                age: 0,
                gender: ''
            },
            show_error: '',
            error_msg: false,
            show_first_edit: false,
            show_couple_first_edit: false
        }
    },
    computed: {
        show_couple () {
            return this.type === TYPE.COUPLE
        },
    },
    watch: {
        'user.gender' (gender) {
            this.changeGender(gender, 'couple')
        },
        'couple.gender' (gender) {
            this.changeGender(gender, 'user')
        }
    },
    methods: {
        goArticle() {
            this.$sendCtmEvtLog('公积金贷款额度计算器-了解计算方法点击')
            wx.navigateTo({
                url: `/web_page?link=${encodeURIComponent('https://mp.weixin.qq.com/s/KPFbYYwk_IR3R-4LfYJSAw')}&title=成都购房通`
            })
        },
        getPrevStart (i, key) {
            const date = i ? this[key][i - 1].start : ''
            if (date) {
                const max_date = new Date(date)
                max_date.setMonth(max_date.getMonth() - 1)
                return formatDate(max_date)
            }
            return ''
        },
        getNextEnd (i, key) {
            const date = (i + 1 === this[`${key}_count`]) ? '' : this[key][i + 1].end
            if (date) {
                const min_date = new Date(date)
                min_date.setMonth(min_date.getMonth() + 1)
                console.error(formatDate(min_date))
                return formatDate(min_date)
            }
            return ''
        },
        getOutNextEnd (i, key, in_key) {
            const next_end = this.getNextEnd(i, key) || ''
            const first_in = this[in_key][this[in_key].length - 1].start || ''
            console.error(next_end, first_in)
            let min_date
            if (next_end && first_in) {
                min_date = Math.min(new Date(first_in).getTime(), new Date(next_end).getTime())
            } else {
                min_date = next_end || first_in
            }
            if (min_date) {
                return formatDate(new Date(min_date))
            }
            return ''
        },
        changeOutFirstEdit (type, val) {
            const type_str = type ? `${type}_` : ''
            const edit_key = `show_${type_str}first_edit`
            if (val && !checkRecordItem(this[`${type_str}in_records`][0])) {
                wx.showToast({
                    title: '您有未填写完整的缴存记录',
                    icon: 'none'
                })
                this[edit_key] = false
            } else {
                this[edit_key] = val
            }
        },
        changeFirstEdit (val) {
            this.changeOutFirstEdit('', val)
        },
        changeCoupleFirstEdit (val) {
            this.changeOutFirstEdit('couple', val)
        },
        changeGender (gender, key) {
            if (gender === '男') {
                this[key].gender = '女'
            } else {
                this[key].gender = '男'
            }
        },
        changeType (type) {
            console.log('type', type)
            this.type = Number(type)
        },
        submit () {
            if (!checkUser(this.user)) {
                wx.showToast({
                    title: '请完善个人信息',
                    icon: 'none'
                })
                return
            }
            if (!checkRecords(this.in_records)) {
                wx.showToast({
                    title: '您有未填写完成的缴存记录',
                    icon: 'none'
                })
                return
            }
            if (this.show_first_edit && !checkRecords(this.out_records)) {
                wx.showToast({
                    title: '您有未填写完成的存取记录',
                    icon: 'none'
                })
                return
            }
            const input = [
                {
                    user: this.user,
                    in_records: this.in_records,
                    out_records: this.out_records
                }
            ]
            if (this.show_couple) {
                if (!checkUser(this.couple)) {
                    wx.showToast({
                        title: '请完善配偶信息',
                        icon: 'none'
                    })
                    return
                }
                if (!checkRecords(this.couple_in_records)) {
                    wx.showToast({
                        title: '您的伴侣有未填写完成的缴存记录',
                        icon: 'none'
                    })
                    return
                }
                if (this.show_couple_first_edit && !checkRecords(this.couple_out_records)) {
                    wx.showToast({
                        title: '您的伴侣有未填写完成的存取记录',
                        icon: 'none'
                    })
                    return
                }
                input.push({
                    user: this.couple,
                    in_records: this.couple_in_records,
                    out_records: this.couple_out_records
                })
            }
            const { err, res } = compute(input)
            if (err) {
                this.show_error = true
                this.error_msg = err
            } else {
                setResult(res)
                wx.navigateTo({
                    url: `/pages/packageB/provident_fund/result`
                })
            }
        }
    }
}
